import React, {useState} from 'react';
import {useDispatch} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import Pagination from '@mui/material/Pagination';
import DiscoverySectionItem from "../../../pages/main/sections/discoverSection/components/DiscoverySectionItem";

interface OrderMainFoodProductListProps {
    selectedCategory: string,
    data: any
}

const OrderMainFoodProductList = (props: OrderMainFoodProductListProps) => {
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const ITEMS_PER_PAGE = 10;
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const navigate = useNavigate();
    const {category, details} = useParams();
    
    const scrollToTop = () => {
        window.scrollTo({ top: 187, behavior: 'smooth' });
    };

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    }

    const handleShowItemDetails = (category: string, name: string) => () => {
        navigate(`${category}/${name}`);
    }

    const renderProductByCategory = () => {
      
      //let dineInDataEntries = props?.data ? props?.data?.filter((item: any) => item?.isDineIn) : [];
      
      console.log("props?.data: ", props?.data);
      console.log("props.data.entries(): ", props?.data?.entries());
      console.log("dineInDataEntries: ",
        Array.from(props?.data?.entries())
              .filter((item: any) => !item.isDineIn)
              .flatMap(([category, items]: any) => items)
      );
      
      const categoriesMap = new Map<string, any[]>();
      const takeOutMap = new Map<string, any[]>();
      const dineInMap = new Map<string, any[]>();
      
      props?.data?.forEach((item: any) => {
          item.category.forEach((category: string) => {
            const normalizedCategory = category.toLowerCase();
            console.log("normalizedCategory: ", normalizedCategory);
            
            if (!categoriesMap.has(normalizedCategory)) {
              categoriesMap.set(normalizedCategory, []);
            }
            categoriesMap.get(normalizedCategory)!.push(item);
            
            if (item?.isDineIn) {
              if (!dineInMap.has(normalizedCategory)) {
                dineInMap.set(normalizedCategory, []);
              }
              dineInMap.get(normalizedCategory)!.push(item);
            } else {
              if (!takeOutMap.has(normalizedCategory)) {
                takeOutMap.set(normalizedCategory, []);
              }
              takeOutMap.get(normalizedCategory)!.push(item);
            }
          });
      });
      
      //console.log("props.data.entries(): ", props?.data.entries());
      //console.log("dineInDataEntries.entries(): ", dineInDataEntries.entries());
      
        const mergedData = props?.data ?
          props.selectedCategory === "All" ?
            Array.from(categoriesMap.entries()).flatMap(([category, items]: any) => items)
            :
            (props.selectedCategory === "Take-out" || props.selectedCategory === "Take out" || props.selectedCategory === "take-out") ?
              Array.from(takeOutMap.entries()).flatMap(([category, items]: any) => items)
              :
              (props.selectedCategory === "Dine-in" || props.selectedCategory === "Dine in" || props.selectedCategory === "dine-in") ?
                Array.from(dineInMap.entries()).flatMap(([category, items]: any) => items)
                :
                  Array.from(categoriesMap.entries()).filter(([category, items]: any) => {
                      return category === props.selectedCategory.toLowerCase();
                  }).flatMap(([category, items]: any) => items)
          :
          [];
        
        const paginatedData = mergedData.slice(startIndex, endIndex - 1);
        const totalPages = Math.ceil(mergedData.length / ITEMS_PER_PAGE);
        
        return (
            <div className="orderMainFoodProductList__container-wrap-map">
                <div className="orderMainFoodProductList__container-items-wrap">
                    {
                        paginatedData.map((item: any, indx: number) => {
                            return (
                                <div
                                     className={`orderMainFoodProductList__container-items-wrap-item ${(indx + 1 > 3) ? "three" : (indx + 1 > 2) ? "two" : ""}`}
                                     key={indx}
                                     onClick={
                                         handleShowItemDetails(
                                           item.category[0].toLowerCase().replace(/\s/g, "-"),
                                           item.data._id
                                         )
                                    }
                                >
                                    <DiscoverySectionItem
                                      isDineIn={item.isDineIn}
                                      image={item.data.image}
                                      name={item.data.name}
                                      priceBefore={item.data.priceBefore}
                                      priceNow={item.data.priceNow}
                                      discount={item.data.discount}
                                      address={item.data?.restaurantId?.address?.name}
                                      onOption={item.data?.onOption}
                                    />
                                </div>
                            )
                        })
                    }
                </div>
                {
                    totalPages > 1 && (
                        <div className="orderMainFoodProductList__container-items-pagination">
                            <div className="orderMainFoodProductList__container-items-pagination-wrap">
                                <Pagination
                                    count={totalPages}
                                    page={currentPage}
                                    onChange={(e, page) => {
                                        handlePageChange(page)
                                        scrollToTop();
                                    }}
                                    shape="rounded"
                                    style={{
                                        color: "#3A3A3A",
                                        backgroundColor: "#fff",
                                        borderRadius: "5px",
                                        padding: "5px",
                                        border: "none",
                                        paddingLeft: currentPage === 1 ? "38px" : "0",
                                        paddingRight: currentPage === totalPages ? "38px" : "0",
                                    }}
                                    hidePrevButton={currentPage === 1}
                                    hideNextButton={currentPage === totalPages}
                                />
                            </div>
                        </div>
                    )
                }
            </div>
        )
    }


    return (
        <div className="orderMainFoodProductList__container">
            <div className="orderMainFoodProductList__container-wrap">
                {
                    renderProductByCategory()
                }
            </div>
        </div>
    );
};

export default OrderMainFoodProductList;